<template>
  <div class="wlx-site-lec-wrapper">
    <header class="u-school-manager-head">
      <el-form :inline="true" size="small" class="site-lec-form">
        <el-form-item>
          <el-input v-model="teaName" placeholder="请输入讲师姓名" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-circle-plus-outline" @click="add">添加</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-delete" @click="deleteAll">删除</el-button>
        </el-form-item>
      </el-form>
    </header>
    <!-- 新增考试 -->
    <el-dialog
      title="新增讲师"
      :visible.sync="addLecturerNoticeVisible"
      :before-close="cancel"
      width="70%"
      :append-to-body="true"
      :close-on-click-modal="false"
    >
      <el-form :inline="true">
        <el-form-item>
          <el-input v-model="allTeaName" placeholder="请输入讲师姓名" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="searchAll">搜索</el-button>
        </el-form-item>
      </el-form>
      <el-table
        ref="multipleeeeTable"
        :data="allList"
        style="width: 100%;"
        @selection-change="handleSelectionChangeAll"
      >
        <el-table-column prop="id" type="selection" width="55"></el-table-column>
        <el-table-column label="序号" type="index" width="50"></el-table-column>
        <el-table-column prop="userName" label="用户名"></el-table-column>
        <el-table-column prop="displayName" label="姓名"></el-table-column>
        <el-table-column prop="dateCreated" label="创建时间"></el-table-column>
        <el-table-column prop="description" label="简介"></el-table-column>
        <el-table-column prop="mobile" label="手机号"></el-table-column>
      </el-table>
      <el-pagination
        background
        @size-change="handleSizeChangeAll"
        @current-change="onPageChangeHandlerAll"
        :current-page="allPageIndex"
        :page-sizes="[8, 25, 50, 100]"
        :page-size="allPageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="allTotal"
        v-show="allTotal>0"
      ></el-pagination>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addLecturerNoticeVisible = false">取 消</el-button>
        <el-button type="primary" @click="addLecturer">确定</el-button>
      </div>
    </el-dialog>
    <div class="u-table-main">
      <el-table
        ref="multipleeeeTable"
        :data="list"
        style="width: 100%;"
        @selection-change="handleSelectionChange"
      >
        <el-table-column prop="id" type="selection" width="55"></el-table-column>
        <el-table-column label="序号" type="index" width="50"></el-table-column>
        <el-table-column prop="userName" label="用户名"></el-table-column>
        <el-table-column prop="displayName" label="姓名"></el-table-column>
        <el-table-column prop="dateCreated" label="创建时间"></el-table-column>
        <el-table-column prop="description" label="简介"></el-table-column>
        <el-table-column prop="mobile" label="手机号"></el-table-column>
        <el-table-column label="操作" width="260">
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="danger"
              class="el-icon-delete"
              @click="deleteById(scope.row.id)"
              titlt="删除"
            ></el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="u-page-con">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="onPageChangeHandler"
        :current-page="pageIndex"
        :page-sizes="[10, 25, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        v-show="total>0"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import NewThumbnail from "../../component/AliyunOSS/NewThumbnail.vue";
export default {
  data() {
    return {
      allList: [],
      allTotal: 0,
      allPageSize: 8,
      allPageIndex: 0,
      allTeaName: "",
      allLecturerId: [],
      /* ******************** */
      list: [],
      total: 0,
      pageSize: 10,
      pageIndex: 1,
      teaName: "",
      lecturerId: [],
      addLecturerNoticeVisible: false
    };
  },
  components: {
    NewThumbnail
  },
  created() {
    this.getLecturerList(1);
  },
  methods: {
    getAllLecturerList(page) {
      var that = this;
      this.$http
        .post("/api/XOrg/Lecturer/getAllLecturerList", {
          teaName: this.allTeaName,
          page: page,
          pageSize: this.allPageSize
        })
        .then(rst => {
          if (rst.code == 1) {
            that.allList = rst.list;
            that.allTotal = rst.pagination.totalCount;
            that.allPageSize = rst.pagination.pageSize;
            that.allPageIndex = rst.pagination.pageIndex;
          }
        });
    },
    onPageChangeHandlerAll(page) {
      this.getAllLecturerList(page);
    },
    handleSizeChangeAll(val) {
      this.allPageSize = val;
      this.getAllLecturerList(1);
    },
    searchAll() {
      this.getAllLecturerList(1);
    },
    handleSelectionChangeAll(val) {
      this.allLecturerId = [];
      val.forEach(element => {
        this.allLecturerId.push(element.id);
      });
    },
    getLecturerList(page) {
      var that = this;
      this.$http
        .post("/api/XOrg/Lecturer/getLecturerList", {
          teaName: this.teaName,
          page: page,
          pageSize: this.pageSize
        })
        .then(rst => {
          if (rst.code == 1) {
            that.list = rst.list;
            that.total = rst.pagination.totalCount;
            that.pageSize = rst.pagination.pageSize;
            that.pageIndex = rst.pagination.pageIndex;
          }
        });
    },
    onPageChangeHandler(page) {
      this.getLecturerList(page);
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getLecturerList(1);
    },
    handleSelectionChange(val) {
      this.lecturerId = [];
      val.forEach(element => {
        this.lecturerId.push(element.id);
      });
    },
    cancel() {
      this.addLecturerNoticeVisible = false;
      this.lecturerId = [];
      this.allLecturerId = [];
    },
    add() {
      this.addLecturerNoticeVisible = true;
      this.getAllLecturerList(1);
    },
    addLecturer() {
      var that = this;
      this.$http
        .post("/api/XOrg/Lecturer/addLecturer", {
          ids: this.allLecturerId
        })
        .then(rst => {
          if (rst.code == 1) {
            this.cancel();
            this.$message.success(rst.msg);
            this.getLecturerList();
          } else {
            this.$message.warning(rst.msg);
          }
        });
    },
    deleteById(id) {
      this.lecturerId = [];
      this.lecturerId.push(id);
      this.$confirm("此操作将删除选中讲师, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.deleteLecturer();
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    search() {
      this.getLecturerList(1);
    },
    deleteAll() {
      if (this.lecturerId.length === 0) {
        this.$message({
          showClose: true,
          message: "请选择考试",
          type: "warning"
        });
        return false;
      }
      this.$confirm("此操作将删除所选讲师, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.deleteLecturer();
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    deleteLecturer() {
      var that = this;
      this.$http
        .post("/api/XOrg/Lecturer/deleteLecturer", {
          ids: this.lecturerId
        })
        .then(rst => {
          if (rst.code == 1) {
            that.$message.success(rst.msg);
            that.getLecturerList();
          } else {
            that.$message.warning(rst.msg);
          }
        });
    }
  }
};
</script>

<style lang="scss">
.wlx-site-lec-wrapper {
  .site-lec-form{
    margin: 13px 62px 0 0;
  }
}
</style>

